export enum TypeOfCompanyInPorts {
  COURIER = 0,
  WASTE_DISPOSAL = 1,
  COURIER_AND_WASTE_DISPOSAL = 2,
  CONTROL = 3,
  ALL = 4,
  OPERATIONAL_SUPPORT = 5,
}
